export default __webpack_public_path__ + "static/media/h5-section1-bg5.3ba39f0b.png";